import React, { FC } from 'react';
import styles from './index.module.scss';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Paths } from '../paths';
import BuyersPage from '../BuyersPage';
import BuyerPage from '../BuyerPage';
import ExpiringContractsPage from '../ExpiringContractsPage';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';

export const AnalyticsRouts: FC = () => {
  const isBuyerProfilesHomePageAvailable = useFeatureFlag(FeatureFlag.AnalyticsHomepage);
  const isExpiringContractsPageAvailable = useFeatureFlag(FeatureFlag.AnalyticsExpiringContracts);
  const isAnalyticsExpiringContractsLight = useFeatureFlag(FeatureFlag.AnalyticsExpiringContractsLight);

  return !!isBuyerProfilesHomePageAvailable ||
    !!isExpiringContractsPageAvailable ||
    !!isAnalyticsExpiringContractsLight ? (
    <div className={styles.content}>
      <Routes>
        <Route path={Paths.BUYER_PAGE} element={<BuyerPage />} />
        <Route path={Paths.BUYERS_PAGE} element={<BuyersPage />} />
        <Route path={Paths.EXPIRING_CONTRACTS_PAGE} element={<ExpiringContractsPage />} />
        <Route
          path={'*'}
          element={
            <Navigate
              to={isBuyerProfilesHomePageAvailable ? Paths.BUYERS_PAGE : Paths.EXPIRING_CONTRACTS_PAGE}
              replace
            />
          }
        />
      </Routes>
    </div>
  ) : (
    <Navigate to={Paths.HOME_PATH} replace />
  );
};

export default AnalyticsRouts;
